export default __webpack_public_path__ + "static/phone-f095f043f3b4891c0b17648604baa8e6.svg";